import { render, staticRenderFns } from "./MergeAffinities.vue?vue&type=template&id=f0e406bc&scoped=true"
import script from "./MergeAffinities.vue?vue&type=script&lang=js"
export * from "./MergeAffinities.vue?vue&type=script&lang=js"
import style0 from "./MergeAffinities.vue?vue&type=style&index=0&id=f0e406bc&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e406bc",
  null
  
)

export default component.exports